import { Header } from '@/components';
import MenuMobile from '@/components/layout/menu/menu.mobile';
import { useToggle } from '@/hooks';
import { isMobile } from '@/utils/mobile.util';
import { memo } from 'react';
import { Outlet } from 'react-router-dom';

import { MenuContext, SessionTimerProvider } from './main-layout';

type IProps = {};

const CreateDetailLayoutComponent = (props: IProps) => {
	const [menuOpen, onToggle, setMenuOpen] = useToggle(isMobile ? false : true);
	return (
		<div className="xl:h-screen bg-blue5 xl:px-9 xl:pb-28 2xl:pb-2.5 xl:overflow-auto">
			{isMobile ? (
				<MenuContext.Provider value={{ menuOpen, onToggle, setMenuOpen }}>
					<SessionTimerProvider>
						<Header />
						<div className="block xl:flex">
							<MenuMobile />
							<div className="bg-springWood h-screen xl:h-[calc(100vh_-_70px)] w-full xl:pb-5 xl:px-9 overflow-auto">
								<Outlet />
							</div>
						</div>
					</SessionTimerProvider>
				</MenuContext.Provider>
			) : (
				<Outlet />
			)}
		</div>
	);
};

export const CreateDetailLayout = memo(CreateDetailLayoutComponent);
